import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/grailed-followers';

export default function Example() {
  return (
    <>
      <Head>
        <title>Grailed Seller Guide: 4 Effective Ways to Actively Grow Your Followers</title>
        <meta
          name='description'
          content='Getting buyers interested in your listing starts with increasing your visibility. To do this, you need to get more users to follow you–and this takes effort, but it is all worth it to gain profit.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/grailed-followers' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/grailed-followers' />
        <meta property='og:title' content='Grailed Seller Guide: 4 Effective Ways to Actively Grow Your Followers' />
        <meta
          property='og:description'
          content='Getting buyers interested in your listing starts with increasing your visibility. To do this, you need to get more users to follow you–and this takes effort, but it is all worth it to gain profit.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-10-20T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-10-20T00:00:00-00:00' />
        <meta property='article:tag' content='Grailed' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
